{"frames": {

"overlays/animal/land/animal_land_01":
{
	"frame": {"x":143,"y":1540,"w":26,"h":20},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":6,"w":26,"h":20},
	"sourceSize": {"w":31,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_02":
{
	"frame": {"x":133,"y":929,"w":25,"h":19},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":6,"w":25,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_03":
{
	"frame": {"x":110,"y":352,"w":28,"h":21},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":5,"w":28,"h":21},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_04":
{
	"frame": {"x":61,"y":700,"w":28,"h":24},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":2,"w":28,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_05":
{
	"frame": {"x":72,"y":206,"w":27,"h":17},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":7,"w":27,"h":17},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_06":
{
	"frame": {"x":177,"y":785,"w":28,"h":25},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":28,"h":25},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_07":
{
	"frame": {"x":151,"y":817,"w":28,"h":25},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":28,"h":25},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_08":
{
	"frame": {"x":178,"y":815,"w":28,"h":25},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":28,"h":25},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_09":
{
	"frame": {"x":72,"y":225,"w":27,"h":23},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":4,"w":27,"h":23},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_10":
{
	"frame": {"x":116,"y":1283,"w":24,"h":22},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":22},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_11":
{
	"frame": {"x":151,"y":756,"w":29,"h":24},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":3,"w":29,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_12":
{
	"frame": {"x":151,"y":847,"w":25,"h":22},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":3,"w":25,"h":22},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_13":
{
	"frame": {"x":88,"y":415,"w":24,"h":20},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":6,"w":24,"h":20},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_14":
{
	"frame": {"x":203,"y":88,"w":30,"h":22},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":22},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_15":
{
	"frame": {"x":32,"y":1289,"w":29,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":2,"w":29,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_16":
{
	"frame": {"x":87,"y":994,"w":28,"h":22},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":4,"w":28,"h":22},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_17":
{
	"frame": {"x":60,"y":326,"w":26,"h":26},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":0,"w":26,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_18":
{
	"frame": {"x":190,"y":1388,"w":22,"h":20},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":22,"h":20},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_19":
{
	"frame": {"x":60,"y":416,"w":26,"h":26},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":0,"w":26,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_20":
{
	"frame": {"x":190,"y":1516,"w":22,"h":20},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":22,"h":20},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_21":
{
	"frame": {"x":171,"y":1338,"w":23,"h":19},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":6,"w":23,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_22":
{
	"frame": {"x":178,"y":845,"w":24,"h":26},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":0,"w":24,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_23":
{
	"frame": {"x":188,"y":901,"w":24,"h":26},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":0,"w":24,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_24":
{
	"frame": {"x":160,"y":928,"w":24,"h":26},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":0,"w":24,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_25":
{
	"frame": {"x":229,"y":538,"w":23,"h":23},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":2,"w":23,"h":23},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_26":
{
	"frame": {"x":229,"y":613,"w":23,"h":22},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":3,"w":23,"h":22},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_27":
{
	"frame": {"x":103,"y":129,"w":22,"h":30},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":0,"w":22,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/land/animal_land_28":
{
	"frame": {"x":110,"y":326,"w":21,"h":24},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":4,"w":21,"h":24},
	"sourceSize": {"w":31,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/water/animal_water_01":
{
	"frame": {"x":188,"y":929,"w":25,"h":26},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":3,"w":25,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/water/animal_water_02":
{
	"frame": {"x":204,"y":62,"w":30,"h":24},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/water/animal_water_03":
{
	"frame": {"x":229,"y":484,"w":25,"h":23},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":5,"w":25,"h":23},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/animal/water/animal_water_04":
{
	"frame": {"x":177,"y":754,"w":29,"h":24},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":29,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_01":
{
	"frame": {"x":1,"y":1,"w":32,"h":31},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":31},
	"sourceSize": {"w":32,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_02":
{
	"frame": {"x":1,"y":34,"w":32,"h":31},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":31},
	"sourceSize": {"w":32,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_03":
{
	"frame": {"x":35,"y":1,"w":32,"h":31},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":31},
	"sourceSize": {"w":32,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_04":
{
	"frame": {"x":1,"y":67,"w":32,"h":31},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":31},
	"sourceSize": {"w":32,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_05":
{
	"frame": {"x":35,"y":34,"w":32,"h":31},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":31},
	"sourceSize": {"w":32,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_06":
{
	"frame": {"x":69,"y":1,"w":32,"h":31},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":31},
	"sourceSize": {"w":32,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_07":
{
	"frame": {"x":1,"y":100,"w":32,"h":31},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":31},
	"sourceSize": {"w":32,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_08":
{
	"frame": {"x":35,"y":67,"w":32,"h":31},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":31},
	"sourceSize": {"w":32,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_09":
{
	"frame": {"x":69,"y":34,"w":32,"h":31},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":31},
	"sourceSize": {"w":32,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_10":
{
	"frame": {"x":103,"y":1,"w":32,"h":31},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":31},
	"sourceSize": {"w":32,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_11":
{
	"frame": {"x":137,"y":1,"w":32,"h":30},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":30},
	"sourceSize": {"w":32,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_12":
{
	"frame": {"x":1,"y":166,"w":31,"h":31},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":31,"h":31},
	"sourceSize": {"w":31,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_13":
{
	"frame": {"x":69,"y":100,"w":32,"h":29},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":1,"w":32,"h":29},
	"sourceSize": {"w":32,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_14":
{
	"frame": {"x":1,"y":133,"w":32,"h":31},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":31},
	"sourceSize": {"w":32,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_15":
{
	"frame": {"x":35,"y":100,"w":32,"h":31},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":31},
	"sourceSize": {"w":32,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_16":
{
	"frame": {"x":103,"y":67,"w":32,"h":28},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":28},
	"sourceSize": {"w":32,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_17":
{
	"frame": {"x":69,"y":67,"w":32,"h":31},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":31},
	"sourceSize": {"w":32,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_18":
{
	"frame": {"x":103,"y":34,"w":32,"h":31},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":31},
	"sourceSize": {"w":32,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_19":
{
	"frame": {"x":204,"y":33,"w":27,"h":31},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":27,"h":31},
	"sourceSize": {"w":31,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_20":
{
	"frame": {"x":35,"y":133,"w":32,"h":30},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":30},
	"sourceSize": {"w":32,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_21":
{
	"frame": {"x":137,"y":33,"w":31,"h":29},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":1,"w":31,"h":29},
	"sourceSize": {"w":31,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_22":
{
	"frame": {"x":1,"y":937,"w":26,"h":31},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":0,"w":26,"h":31},
	"sourceSize": {"w":31,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_23":
{
	"frame": {"x":170,"y":62,"w":32,"h":23},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":32,"h":23},
	"sourceSize": {"w":32,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_24":
{
	"frame": {"x":170,"y":33,"w":27,"h":32},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":27,"h":32},
	"sourceSize": {"w":31,"h":32},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_25":
{
	"frame": {"x":1,"y":1003,"w":26,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":26,"h":30},
	"sourceSize": {"w":31,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_26":
{
	"frame": {"x":169,"y":87,"w":32,"h":20},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":10,"w":32,"h":20},
	"sourceSize": {"w":32,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_27":
{
	"frame": {"x":1,"y":1035,"w":27,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":0,"w":27,"h":30},
	"sourceSize": {"w":31,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_28":
{
	"frame": {"x":1,"y":970,"w":26,"h":31},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":0,"w":26,"h":31},
	"sourceSize": {"w":31,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_29":
{
	"frame": {"x":177,"y":556,"w":25,"h":18},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":12,"w":25,"h":18},
	"sourceSize": {"w":31,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_30":
{
	"frame": {"x":177,"y":583,"w":25,"h":18},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":12,"w":25,"h":18},
	"sourceSize": {"w":31,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_31":
{
	"frame": {"x":237,"y":33,"w":15,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":16,"y":0,"w":15,"h":30},
	"sourceSize": {"w":31,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_32":
{
	"frame": {"x":103,"y":929,"w":28,"h":19},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":0,"w":28,"h":19},
	"sourceSize": {"w":31,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_33":
{
	"frame": {"x":121,"y":819,"w":28,"h":21},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":28,"h":21},
	"sourceSize": {"w":31,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_34":
{
	"frame": {"x":90,"y":441,"w":18,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":18,"h":30},
	"sourceSize": {"w":31,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_35":
{
	"frame": {"x":52,"y":195,"w":15,"h":19},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":11,"w":15,"h":19},
	"sourceSize": {"w":31,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_36":
{
	"frame": {"x":241,"y":1510,"w":22,"h":11},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":19,"w":22,"h":11},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_37":
{
	"frame": {"x":142,"y":455,"w":15,"h":21},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":16,"y":9,"w":15,"h":21},
	"sourceSize": {"w":31,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_38":
{
	"frame": {"x":141,"y":1639,"w":19,"h":22},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":12,"y":0,"w":19,"h":22},
	"sourceSize": {"w":31,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_39":
{
	"frame": {"x":221,"y":1185,"w":21,"h":13},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":0,"w":21,"h":13},
	"sourceSize": {"w":30,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_40":
{
	"frame": {"x":215,"y":985,"w":16,"h":19},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":16,"h":19},
	"sourceSize": {"w":31,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_41":
{
	"frame": {"x":230,"y":1603,"w":20,"h":18},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":7,"y":7,"w":20,"h":18},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/forest/forest_42":
{
	"frame": {"x":166,"y":1385,"w":23,"h":22},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":4,"w":23,"h":22},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_01":
{
	"frame": {"x":229,"y":254,"w":29,"h":23},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":4,"w":29,"h":23},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_02":
{
	"frame": {"x":111,"y":993,"w":22,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":3,"w":22,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_03":
{
	"frame": {"x":215,"y":921,"w":19,"h":20},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":10,"y":8,"w":19,"h":20},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_04":
{
	"frame": {"x":166,"y":1410,"w":24,"h":21},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":4,"w":24,"h":21},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_05":
{
	"frame": {"x":1,"y":1067,"w":27,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":27,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_06":
{
	"frame": {"x":188,"y":957,"w":25,"h":25},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":0,"w":25,"h":25},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_07":
{
	"frame": {"x":1,"y":423,"w":29,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":29,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_08":
{
	"frame": {"x":207,"y":695,"w":28,"h":26},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":28,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_09":
{
	"frame": {"x":151,"y":787,"w":24,"h":28},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":2,"w":24,"h":28},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_10":
{
	"frame": {"x":187,"y":1592,"w":24,"h":19},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":11,"w":24,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_11":
{
	"frame": {"x":229,"y":285,"w":23,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":2,"w":23,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_12":
{
	"frame": {"x":117,"y":1684,"w":25,"h":17},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":9,"w":25,"h":17},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_13":
{
	"frame": {"x":144,"y":1568,"w":19,"h":25},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":0,"w":19,"h":25},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_14":
{
	"frame": {"x":142,"y":1283,"w":25,"h":24},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":6,"w":25,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_15":
{
	"frame": {"x":167,"y":1488,"w":24,"h":21},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":9,"w":24,"h":21},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_16":
{
	"frame": {"x":169,"y":109,"w":25,"h":30},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":25,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_17":
{
	"frame": {"x":208,"y":1489,"w":25,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":13,"w":25,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_18":
{
	"frame": {"x":240,"y":1460,"w":19,"h":12},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":5,"w":19,"h":12},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_19":
{
	"frame": {"x":205,"y":813,"w":18,"h":10},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":7,"y":20,"w":18,"h":10},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_20":
{
	"frame": {"x":204,"y":772,"w":19,"h":11},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":11,"w":19,"h":11},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_21":
{
	"frame": {"x":236,"y":1112,"w":16,"h":19},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":9,"w":16,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_22":
{
	"frame": {"x":144,"y":1684,"w":17,"h":17},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":11,"w":17,"h":17},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_23":
{
	"frame": {"x":214,"y":898,"w":20,"h":21},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":6,"w":20,"h":21},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_24":
{
	"frame": {"x":220,"y":1104,"w":18,"h":14},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":9,"y":6,"w":18,"h":14},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_25":
{
	"frame": {"x":233,"y":128,"w":30,"h":19},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":4,"w":30,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_26":
{
	"frame": {"x":236,"y":1198,"w":16,"h":17},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":5,"w":16,"h":17},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/land/island_land_27":
{
	"frame": {"x":236,"y":1178,"w":18,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":8,"y":9,"w":18,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_01":
{
	"frame": {"x":201,"y":112,"w":30,"h":24},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":4,"w":30,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_02":
{
	"frame": {"x":72,"y":299,"w":25,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":25,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_03":
{
	"frame": {"x":140,"y":1660,"w":22,"h":21},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":8,"y":8,"w":22,"h":21},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_04":
{
	"frame": {"x":117,"y":1628,"w":26,"h":22},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":4,"w":26,"h":22},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_05":
{
	"frame": {"x":1,"y":711,"w":28,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":28,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_06":
{
	"frame": {"x":160,"y":954,"w":26,"h":26},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":26,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_07":
{
	"frame": {"x":171,"y":1,"w":30,"h":30},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":30,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_08":
{
	"frame": {"x":1,"y":1163,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_09":
{
	"frame": {"x":123,"y":697,"w":25,"h":28},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":2,"w":25,"h":28},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_10":
{
	"frame": {"x":88,"y":1170,"w":26,"h":19},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":11,"w":26,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_11":
{
	"frame": {"x":150,"y":696,"w":25,"h":28},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":2,"w":25,"h":28},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_12":
{
	"frame": {"x":177,"y":499,"w":27,"h":18},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":9,"w":27,"h":18},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_13":
{
	"frame": {"x":90,"y":1249,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":0,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_14":
{
	"frame": {"x":117,"y":1406,"w":27,"h":24},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":6,"w":27,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_15":
{
	"frame": {"x":110,"y":399,"w":25,"h":21},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":9,"w":25,"h":21},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_16":
{
	"frame": {"x":1,"y":1099,"w":27,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":27,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_17":
{
	"frame": {"x":235,"y":98,"w":28,"h":17},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":13,"w":28,"h":17},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_18":
{
	"frame": {"x":220,"y":1080,"w":22,"h":14},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":5,"w":22,"h":14},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_19":
{
	"frame": {"x":119,"y":1307,"w":20,"h":10},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":20,"w":20,"h":10},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_20":
{
	"frame": {"x":132,"y":979,"w":22,"h":12},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":11,"w":22,"h":12},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_21":
{
	"frame": {"x":208,"y":1616,"w":18,"h":20},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":9,"w":18,"h":20},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_22":
{
	"frame": {"x":215,"y":943,"w":19,"h":19},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":11,"w":19,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_23":
{
	"frame": {"x":189,"y":1410,"w":22,"h":22},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":6,"w":22,"h":22},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/island/water/island_water_24":
{
	"frame": {"x":110,"y":382,"w":21,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":7,"y":6,"w":21,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/campsite_01":
{
	"frame": {"x":188,"y":984,"w":25,"h":25},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":1,"w":25,"h":25},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/campsite_02":
{
	"frame": {"x":169,"y":1283,"w":25,"h":25},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":1,"w":25,"h":25},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/castle_ruin":
{
	"frame": {"x":88,"y":1024,"w":28,"h":25},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":28,"h":25},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/dragon_green":
{
	"frame": {"x":1,"y":839,"w":30,"h":28},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":2,"w":30,"h":28},
	"sourceSize": {"w":31,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/dragon_red":
{
	"frame": {"x":1,"y":1195,"w":30,"h":28},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":2,"w":30,"h":28},
	"sourceSize": {"w":31,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/flying_castle":
{
	"frame": {"x":236,"y":65,"w":16,"h":31},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":0,"w":16,"h":31},
	"sourceSize": {"w":30,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/geysers_01":
{
	"frame": {"x":165,"y":1566,"w":24,"h":20},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":3,"w":24,"h":20},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/geysers_02":
{
	"frame": {"x":165,"y":1592,"w":24,"h":20},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":3,"w":24,"h":20},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/geysers_03":
{
	"frame": {"x":117,"y":1493,"w":24,"h":26},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":0,"w":24,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/geysers_04":
{
	"frame": {"x":117,"y":1656,"w":21,"h":26},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":0,"w":21,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/geysers_05":
{
	"frame": {"x":169,"y":1310,"w":25,"h":26},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":0,"w":25,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/geysers_06":
{
	"frame": {"x":135,"y":993,"w":22,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":0,"w":22,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/graveyard_01":
{
	"frame": {"x":188,"y":1540,"w":19,"h":24},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":1,"w":19,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/graveyard_02":
{
	"frame": {"x":187,"y":1566,"w":19,"h":24},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":1,"w":19,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/graveyard_03":
{
	"frame": {"x":117,"y":1521,"w":25,"h":24},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":5,"w":25,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/graveyard_04":
{
	"frame": {"x":117,"y":1548,"w":25,"h":24},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":5,"w":25,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/monster_01":
{
	"frame": {"x":142,"y":426,"w":27,"h":21},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":2,"w":27,"h":21},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/monster_02":
{
	"frame": {"x":137,"y":96,"w":30,"h":22},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":2,"w":30,"h":22},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/monster_03":
{
	"frame": {"x":135,"y":120,"w":30,"h":22},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":2,"w":30,"h":22},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/monster_04":
{
	"frame": {"x":213,"y":1410,"w":22,"h":20},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":4,"w":22,"h":20},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/monster_05":
{
	"frame": {"x":230,"y":1438,"w":22,"h":20},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":4,"w":22,"h":20},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/misc/worm_nest":
{
	"frame": {"x":158,"y":1703,"w":23,"h":19},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":3,"w":23,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/mountainrocks/mountainrocks_01":
{
	"frame": {"x":1,"y":743,"w":28,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":28,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/mountainrocks/mountainrocks_02":
{
	"frame": {"x":226,"y":1489,"w":25,"h":13},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":10,"w":25,"h":13},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/mountainrocks/mountainrocks_03":
{
	"frame": {"x":143,"y":1514,"w":24,"h":22},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":7,"w":24,"h":22},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/mountainrocks/mountainrocks_04":
{
	"frame": {"x":117,"y":1435,"w":27,"h":24},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":6,"w":27,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/mountainrocks/mountainrocks_05":
{
	"frame": {"x":1,"y":455,"w":29,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":29,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/mountainrocks/mountainrocks_06":
{
	"frame": {"x":103,"y":900,"w":26,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":3,"w":26,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/mountainrocks/mountainrocks_07":
{
	"frame": {"x":121,"y":759,"w":28,"h":28},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":1,"w":28,"h":28},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/mountainrocks/mountainrocks_08":
{
	"frame": {"x":1,"y":199,"w":30,"h":30},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":30,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/mountainrocks/mountainrocks_09":
{
	"frame": {"x":1,"y":775,"w":28,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":28,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/mountainrocks/mountainrocks_10":
{
	"frame": {"x":221,"y":1158,"w":25,"h":13},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":10,"w":25,"h":13},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/mountainrocks/mountainrocks_11":
{
	"frame": {"x":166,"y":1359,"w":24,"h":22},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":7,"w":24,"h":22},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/mountainrocks/mountainrocks_12":
{
	"frame": {"x":117,"y":1464,"w":27,"h":24},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":6,"w":27,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/mountainrocks/mountainrocks_13":
{
	"frame": {"x":1,"y":487,"w":29,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":29,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/mountainrocks/mountainrocks_14":
{
	"frame": {"x":131,"y":900,"w":26,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":3,"w":26,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/mountainrocks/mountainrocks_15":
{
	"frame": {"x":121,"y":789,"w":28,"h":28},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":1,"w":28,"h":28},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/mountainrocks/mountainrocks_16":
{
	"frame": {"x":69,"y":131,"w":30,"h":30},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":30,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/ship/ship_01":
{
	"frame": {"x":167,"y":1514,"w":24,"h":21},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":3,"w":24,"h":21},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/ship/ship_02":
{
	"frame": {"x":159,"y":900,"w":27,"h":26},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":0,"w":27,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/ship/ship_03":
{
	"frame": {"x":165,"y":1540,"w":24,"h":21},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":3,"w":24,"h":21},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/ship/ship_04":
{
	"frame": {"x":132,"y":950,"w":27,"h":26},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":0,"w":27,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/ship/ship_05":
{
	"frame": {"x":88,"y":354,"w":27,"h":20},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":5,"w":27,"h":20},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/ship/ship_06":
{
	"frame": {"x":117,"y":1575,"w":25,"h":25},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":3,"w":25,"h":25},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/ship/ship_07":
{
	"frame": {"x":208,"y":1570,"w":20,"h":21},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":4,"w":20,"h":21},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/ship/ship_08":
{
	"frame": {"x":165,"y":1632,"w":23,"h":20},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":4,"w":23,"h":20},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/ship/ship_09":
{
	"frame": {"x":214,"y":1385,"w":23,"h":20},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":4,"w":23,"h":20},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/ship/ship_10":
{
	"frame": {"x":208,"y":1593,"w":20,"h":21},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":4,"w":20,"h":21},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/ship/ship_11":
{
	"frame": {"x":177,"y":528,"w":26,"h":18},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":9,"w":26,"h":18},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/ship/ship_12":
{
	"frame": {"x":189,"y":1460,"w":26,"h":17},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":9,"w":26,"h":17},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_01":
{
	"frame": {"x":235,"y":1133,"w":23,"h":17},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":0,"w":23,"h":17},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_02":
{
	"frame": {"x":235,"y":1553,"w":23,"h":17},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":0,"w":23,"h":17},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_03":
{
	"frame": {"x":230,"y":1578,"w":23,"h":17},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":0,"w":23,"h":17},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_04":
{
	"frame": {"x":177,"y":610,"w":25,"h":18},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":11,"w":25,"h":18},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_05":
{
	"frame": {"x":143,"y":1433,"w":26,"h":21},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":4,"w":26,"h":21},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_06":
{
	"frame": {"x":33,"y":199,"w":23,"h":17},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":4,"w":23,"h":17},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_07":
{
	"frame": {"x":144,"y":1595,"w":25,"h":19},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":25,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_08":
{
	"frame": {"x":143,"y":1461,"w":22,"h":25},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":4,"w":22,"h":25},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_09":
{
	"frame": {"x":143,"y":1377,"w":21,"h":26},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":4,"w":21,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_10":
{
	"frame": {"x":199,"y":138,"w":26,"h":30},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":0,"w":26,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_11":
{
	"frame": {"x":229,"y":430,"w":23,"h":25},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":1,"w":23,"h":25},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_12":
{
	"frame": {"x":60,"y":384,"w":26,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":26,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_13":
{
	"frame": {"x":229,"y":457,"w":23,"h":25},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":1,"w":23,"h":25},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_14":
{
	"frame": {"x":189,"y":1434,"w":24,"h":20},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":5,"w":24,"h":20},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_15":
{
	"frame": {"x":144,"y":1622,"w":19,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":0,"w":19,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_16":
{
	"frame": {"x":139,"y":1353,"w":25,"h":22},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":1,"w":25,"h":22},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_17":
{
	"frame": {"x":217,"y":855,"w":17,"h":23},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":0,"w":17,"h":23},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_18":
{
	"frame": {"x":1,"y":1131,"w":27,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":0,"w":27,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_19":
{
	"frame": {"x":60,"y":354,"w":26,"h":28},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":1,"w":26,"h":28},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_20":
{
	"frame": {"x":101,"y":153,"w":22,"h":30},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":0,"w":22,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_21":
{
	"frame": {"x":90,"y":1278,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_22":
{
	"frame": {"x":115,"y":1022,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":0,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_23":
{
	"frame": {"x":72,"y":250,"w":27,"h":22},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":1,"w":27,"h":22},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_24":
{
	"frame": {"x":189,"y":1674,"w":15,"h":9},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":8,"y":8,"w":15,"h":9},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_25":
{
	"frame": {"x":177,"y":724,"w":28,"h":26},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":4,"w":28,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_26":
{
	"frame": {"x":32,"y":423,"w":26,"h":28},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":1,"w":26,"h":28},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_27":
{
	"frame": {"x":166,"y":1436,"w":21,"h":23},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":3,"w":21,"h":23},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_28":
{
	"frame": {"x":1,"y":1227,"w":28,"h":29},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":28,"h":29},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_29":
{
	"frame": {"x":1,"y":519,"w":29,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":29,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_30":
{
	"frame": {"x":211,"y":1434,"w":17,"h":24},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":17,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_31":
{
	"frame": {"x":217,"y":777,"w":17,"h":24},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":17,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_32":
{
	"frame": {"x":217,"y":803,"w":17,"h":24},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":17,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_33":
{
	"frame": {"x":52,"y":165,"w":15,"h":28},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":9,"y":0,"w":15,"h":28},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_34":
{
	"frame": {"x":60,"y":854,"w":15,"h":28},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":9,"y":0,"w":15,"h":28},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/structure/structure_35":
{
	"frame": {"x":87,"y":964,"w":15,"h":28},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":9,"y":0,"w":15,"h":28},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_01":
{
	"frame": {"x":141,"y":1022,"w":22,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":0,"w":22,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_02":
{
	"frame": {"x":141,"y":1022,"w":22,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":0,"w":22,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_03":
{
	"frame": {"x":69,"y":163,"w":24,"h":30},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":0,"w":24,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_04":
{
	"frame": {"x":231,"y":160,"w":21,"h":28},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":7,"y":0,"w":21,"h":28},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_05":
{
	"frame": {"x":217,"y":1003,"w":17,"h":23},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":12,"y":0,"w":17,"h":23},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_06":
{
	"frame": {"x":229,"y":563,"w":23,"h":23},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":0,"w":23,"h":23},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_07":
{
	"frame": {"x":101,"y":177,"w":22,"h":30},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":0,"w":22,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_08":
{
	"frame": {"x":1,"y":1258,"w":29,"h":29},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":29,"h":29},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_09":
{
	"frame": {"x":229,"y":190,"w":23,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":0,"w":23,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_10":
{
	"frame": {"x":1,"y":871,"w":27,"h":31},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":27,"h":31},
	"sourceSize": {"w":30,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_11":
{
	"frame": {"x":229,"y":588,"w":23,"h":23},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":0,"w":23,"h":23},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_12":
{
	"frame": {"x":199,"y":166,"w":22,"h":30},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":0,"w":22,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_13":
{
	"frame": {"x":1,"y":1289,"w":29,"h":29},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":29,"h":29},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_14":
{
	"frame": {"x":229,"y":222,"w":23,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":0,"w":23,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_15":
{
	"frame": {"x":1,"y":904,"w":27,"h":31},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":27,"h":31},
	"sourceSize": {"w":30,"h":31},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_16":
{
	"frame": {"x":1,"y":807,"w":28,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":28,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_17":
{
	"frame": {"x":190,"y":1488,"w":16,"h":26},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":8,"y":0,"w":16,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_18":
{
	"frame": {"x":30,"y":1320,"w":20,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":0,"w":20,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_19":
{
	"frame": {"x":69,"y":189,"w":15,"h":30},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":8,"y":0,"w":15,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_20":
{
	"frame": {"x":30,"y":1352,"w":22,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":0,"w":22,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_21":
{
	"frame": {"x":88,"y":326,"w":20,"h":26},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":8,"y":1,"w":20,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_22":
{
	"frame": {"x":188,"y":871,"w":22,"h":28},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":1,"w":22,"h":28},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_23":
{
	"frame": {"x":1,"y":551,"w":29,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":1,"y":0,"w":29,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_24":
{
	"frame": {"x":88,"y":903,"w":13,"h":29},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":9,"y":1,"w":13,"h":29},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_25":
{
	"frame": {"x":237,"y":695,"w":15,"h":29},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":9,"y":0,"w":15,"h":29},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_26":
{
	"frame": {"x":101,"y":201,"w":15,"h":30},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":14,"y":0,"w":15,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_27":
{
	"frame": {"x":215,"y":964,"w":19,"h":19},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":9,"y":7,"w":19,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_28":
{
	"frame": {"x":88,"y":1054,"w":26,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":3,"w":26,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_29":
{
	"frame": {"x":230,"y":1623,"w":21,"h":18},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":7,"y":7,"w":21,"h":18},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_30":
{
	"frame": {"x":236,"y":1158,"w":16,"h":18},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":8,"y":5,"w":16,"h":18},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_31":
{
	"frame": {"x":72,"y":274,"w":27,"h":23},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":5,"w":27,"h":23},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_32":
{
	"frame": {"x":150,"y":726,"w":25,"h":28},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":2,"w":25,"h":28},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_33":
{
	"frame": {"x":103,"y":97,"w":30,"h":30},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":30,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_34":
{
	"frame": {"x":229,"y":401,"w":27,"h":23},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":4,"w":27,"h":23},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_35":
{
	"frame": {"x":1,"y":583,"w":29,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":29,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_36":
{
	"frame": {"x":229,"y":511,"w":25,"h":23},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":2,"y":2,"w":25,"h":23},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_37":
{
	"frame": {"x":196,"y":1330,"w":24,"h":24},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":0,"w":24,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_38":
{
	"frame": {"x":50,"y":280,"w":17,"h":21},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":9,"y":6,"w":17,"h":21},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_39":
{
	"frame": {"x":1,"y":615,"w":29,"h":30},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":0,"w":29,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_40":
{
	"frame": {"x":143,"y":1488,"w":22,"h":24},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":2,"w":22,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_41":
{
	"frame": {"x":117,"y":1602,"w":25,"h":24},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":4,"w":25,"h":24},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"overlays/vegetation/vegetation_42":
{
	"frame": {"x":143,"y":1405,"w":21,"h":26},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":8,"y":0,"w":21,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/deadplains_tile_01":
{
	"frame": {"x":1,"y":1320,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/deadplains_tile_02":
{
	"frame": {"x":1,"y":1352,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/deadplains_tile_03":
{
	"frame": {"x":1,"y":1384,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/deadplains_tile_04":
{
	"frame": {"x":1,"y":1416,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/deadplains_tile_05":
{
	"frame": {"x":1,"y":1448,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/deadplains_tile_06":
{
	"frame": {"x":1,"y":1480,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/deadplains_tile_07":
{
	"frame": {"x":1,"y":1512,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/deadplains_tile_08":
{
	"frame": {"x":1,"y":1544,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/deadplains_tile_09":
{
	"frame": {"x":1,"y":1576,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/deadplains_tile_10":
{
	"frame": {"x":1,"y":1608,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/deadplains_tile_11":
{
	"frame": {"x":1,"y":1640,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/deadplains_tile_12":
{
	"frame": {"x":1,"y":1672,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/deadplains_tile_13":
{
	"frame": {"x":167,"y":136,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/deadplains_tile_14":
{
	"frame": {"x":133,"y":172,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/deadplains_tile_15":
{
	"frame": {"x":197,"y":190,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/deadplains_tile_16":
{
	"frame": {"x":30,"y":1384,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_1-0":
{
	"frame": {"x":50,"y":384,"w":18,"h":7},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":18,"h":7},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_1-1":
{
	"frame": {"x":236,"y":1272,"w":14,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":16,"y":3,"w":14,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_1-2":
{
	"frame": {"x":222,"y":1286,"w":12,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":18,"y":15,"w":12,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_1-3":
{
	"frame": {"x":50,"y":324,"w":18,"h":8},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":22,"w":18,"h":8},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_1-4":
{
	"frame": {"x":238,"y":1534,"w":14,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":15,"w":14,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_1-5":
{
	"frame": {"x":221,"y":1250,"w":13,"h":16},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":13,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_2-0":
{
	"frame": {"x":236,"y":726,"w":24,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_2-1":
{
	"frame": {"x":87,"y":935,"w":14,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":16,"y":3,"w":14,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_2-2":
{
	"frame": {"x":223,"y":1356,"w":24,"h":15},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":15,"w":24,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_2-3":
{
	"frame": {"x":212,"y":1536,"w":24,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":15,"w":24,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_2-4":
{
	"frame": {"x":241,"y":637,"w":11,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":11,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_2-5":
{
	"frame": {"x":236,"y":752,"w":24,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_3-0":
{
	"frame": {"x":116,"y":1051,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_3-1":
{
	"frame": {"x":116,"y":1080,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_3-2":
{
	"frame": {"x":34,"y":166,"w":30,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":14,"w":30,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_3-3":
{
	"frame": {"x":116,"y":1109,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_3-4":
{
	"frame": {"x":116,"y":1138,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_3-5":
{
	"frame": {"x":167,"y":165,"w":30,"h":23},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":23},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_4-0":
{
	"frame": {"x":116,"y":1167,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_4-1":
{
	"frame": {"x":30,"y":1416,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_4-2":
{
	"frame": {"x":30,"y":1448,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_4-3":
{
	"frame": {"x":116,"y":1196,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_4-4":
{
	"frame": {"x":30,"y":1480,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_4-5":
{
	"frame": {"x":30,"y":1512,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_5-0":
{
	"frame": {"x":30,"y":1544,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_5-1":
{
	"frame": {"x":30,"y":1576,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_5-2":
{
	"frame": {"x":30,"y":1608,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_5-3":
{
	"frame": {"x":30,"y":1640,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_5-4":
{
	"frame": {"x":30,"y":1672,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/deadplains/transition/deadplains_tran_5-5":
{
	"frame": {"x":133,"y":201,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/desert_tile_01":
{
	"frame": {"x":165,"y":215,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/desert_tile_02":
{
	"frame": {"x":197,"y":219,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/desert_tile_03":
{
	"frame": {"x":29,"y":937,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/desert_tile_04":
{
	"frame": {"x":29,"y":969,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/desert_tile_05":
{
	"frame": {"x":29,"y":1001,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/desert_tile_06":
{
	"frame": {"x":30,"y":1033,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/desert_tile_07":
{
	"frame": {"x":30,"y":1065,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/desert_tile_08":
{
	"frame": {"x":30,"y":1097,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/desert_tile_09":
{
	"frame": {"x":30,"y":1129,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/desert_tile_10":
{
	"frame": {"x":30,"y":1161,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/desert_tile_11":
{
	"frame": {"x":31,"y":1193,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/desert_tile_12":
{
	"frame": {"x":31,"y":1225,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/desert_tile_13":
{
	"frame": {"x":32,"y":1257,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/desert_tile_14":
{
	"frame": {"x":52,"y":1320,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/desert_tile_15":
{
	"frame": {"x":54,"y":1352,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_1-0":
{
	"frame": {"x":50,"y":344,"w":18,"h":8},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":18,"h":8},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_1-1":
{
	"frame": {"x":203,"y":754,"w":12,"h":16},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":18,"y":3,"w":12,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_1-2":
{
	"frame": {"x":222,"y":1303,"w":12,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":18,"y":15,"w":12,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_1-3":
{
	"frame": {"x":165,"y":1654,"w":18,"h":6},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":24,"w":18,"h":6},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_1-4":
{
	"frame": {"x":194,"y":1618,"w":11,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":15,"w":11,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_1-5":
{
	"frame": {"x":206,"y":1674,"w":13,"h":14},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":4,"w":13,"h":14},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_2-0":
{
	"frame": {"x":236,"y":778,"w":24,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_2-1":
{
	"frame": {"x":110,"y":1319,"w":14,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":16,"y":3,"w":14,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_2-2":
{
	"frame": {"x":220,"y":1028,"w":24,"h":14},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":16,"w":24,"h":14},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_2-3":
{
	"frame": {"x":220,"y":1054,"w":24,"h":14},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":16,"w":24,"h":14},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_2-4":
{
	"frame": {"x":126,"y":1319,"w":14,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":14,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_2-5":
{
	"frame": {"x":236,"y":804,"w":24,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_3-0":
{
	"frame": {"x":116,"y":1225,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_3-1":
{
	"frame": {"x":229,"y":314,"w":23,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":7,"y":3,"w":23,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_3-2":
{
	"frame": {"x":1,"y":1704,"w":30,"h":18},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":12,"w":30,"h":18},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_3-3":
{
	"frame": {"x":116,"y":1254,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_3-4":
{
	"frame": {"x":89,"y":1191,"w":25,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":25,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_3-5":
{
	"frame": {"x":30,"y":871,"w":30,"h":19},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_4-0":
{
	"frame": {"x":122,"y":842,"w":27,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":3,"w":27,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_4-1":
{
	"frame": {"x":59,"y":1384,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_4-2":
{
	"frame": {"x":59,"y":1416,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_4-3":
{
	"frame": {"x":89,"y":1220,"w":25,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":25,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_4-4":
{
	"frame": {"x":59,"y":1448,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_4-5":
{
	"frame": {"x":59,"y":1480,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_5-1":
{
	"frame": {"x":59,"y":1512,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_5-2":
{
	"frame": {"x":59,"y":1544,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_5-3":
{
	"frame": {"x":59,"y":1576,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_5-4":
{
	"frame": {"x":59,"y":1608,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_5-5":
{
	"frame": {"x":59,"y":1640,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/desert/transition/desert_tran_5-9":
{
	"frame": {"x":59,"y":1672,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/grass_tile_01":
{
	"frame": {"x":30,"y":903,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/grass_tile_02":
{
	"frame": {"x":31,"y":711,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/grass_tile_03":
{
	"frame": {"x":31,"y":743,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/grass_tile_04":
{
	"frame": {"x":31,"y":775,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/grass_tile_05":
{
	"frame": {"x":31,"y":807,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_1-0":
{
	"frame": {"x":228,"y":1643,"w":18,"h":7},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":18,"h":7},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_1-1":
{
	"frame": {"x":236,"y":1217,"w":17,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":13,"y":3,"w":17,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_1-2":
{
	"frame": {"x":240,"y":1340,"w":12,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":18,"y":15,"w":12,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_1-3":
{
	"frame": {"x":180,"y":1662,"w":18,"h":7},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":23,"w":18,"h":7},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_1-4":
{
	"frame": {"x":163,"y":1662,"w":15,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":15,"w":15,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_1-5":
{
	"frame": {"x":236,"y":1288,"w":14,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":14,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_2-0":
{
	"frame": {"x":236,"y":830,"w":24,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_2-1":
{
	"frame": {"x":241,"y":666,"w":11,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":19,"y":3,"w":11,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_2-2":
{
	"frame": {"x":209,"y":1553,"w":24,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":15,"w":24,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_2-3":
{
	"frame": {"x":33,"y":224,"w":24,"h":15},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":15,"w":24,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_2-4":
{
	"frame": {"x":90,"y":1307,"w":10,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":10,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_2-5":
{
	"frame": {"x":236,"y":856,"w":24,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_3-0":
{
	"frame": {"x":229,"y":343,"w":23,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":7,"y":3,"w":23,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_3-1":
{
	"frame": {"x":142,"y":1051,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_3-2":
{
	"frame": {"x":51,"y":871,"w":30,"h":19},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":11,"w":30,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_3-3":
{
	"frame": {"x":142,"y":1080,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_3-4":
{
	"frame": {"x":142,"y":1109,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_3-5":
{
	"frame": {"x":33,"y":1704,"w":30,"h":18},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":18},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_4-0":
{
	"frame": {"x":142,"y":1138,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_4-1":
{
	"frame": {"x":31,"y":839,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_4-2":
{
	"frame": {"x":59,"y":903,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_4-3":
{
	"frame": {"x":142,"y":1254,"w":25,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":25,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_4-4":
{
	"frame": {"x":58,"y":935,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_4-5":
{
	"frame": {"x":58,"y":967,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_5-0":
{
	"frame": {"x":58,"y":999,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_5-1":
{
	"frame": {"x":59,"y":1031,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_5-2":
{
	"frame": {"x":59,"y":1063,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_5-3":
{
	"frame": {"x":59,"y":1095,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_5-4":
{
	"frame": {"x":59,"y":1127,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/plain/grass_tran_5-5":
{
	"frame": {"x":59,"y":1159,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_1-0":
{
	"frame": {"x":50,"y":364,"w":18,"h":8},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":18,"h":8},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_1-1":
{
	"frame": {"x":236,"y":1391,"w":13,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":17,"y":3,"w":13,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_1-2":
{
	"frame": {"x":230,"y":1670,"w":13,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":17,"y":15,"w":13,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_1-3":
{
	"frame": {"x":207,"y":1653,"w":18,"h":7},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":23,"w":18,"h":7},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_1-4":
{
	"frame": {"x":240,"y":1357,"w":12,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":15,"w":12,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_1-5":
{
	"frame": {"x":183,"y":1711,"w":11,"h":17},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":11,"h":17},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_2-0":
{
	"frame": {"x":217,"y":829,"w":24,"h":17},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":17},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_2-1":
{
	"frame": {"x":142,"y":1338,"w":13,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":17,"y":3,"w":13,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_2-2":
{
	"frame": {"x":33,"y":250,"w":24,"h":15},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":15,"w":24,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_2-3":
{
	"frame": {"x":33,"y":276,"w":24,"h":15},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":15,"w":24,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_2-4":
{
	"frame": {"x":190,"y":1359,"w":13,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":13,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_2-5":
{
	"frame": {"x":212,"y":1516,"w":24,"h":18},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":18},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_3-0":
{
	"frame": {"x":142,"y":1167,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_3-1":
{
	"frame": {"x":159,"y":982,"w":25,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":3,"w":25,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_3-2":
{
	"frame": {"x":101,"y":218,"w":30,"h":19},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":11,"w":30,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_3-3":
{
	"frame": {"x":142,"y":1196,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_3-4":
{
	"frame": {"x":142,"y":1225,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_3-5":
{
	"frame": {"x":133,"y":230,"w":30,"h":20},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":20},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_4-0":
{
	"frame": {"x":101,"y":871,"w":27,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":3,"y":3,"w":27,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_4-1":
{
	"frame": {"x":60,"y":1191,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_4-2":
{
	"frame": {"x":60,"y":1223,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_4-3":
{
	"frame": {"x":88,"y":1083,"w":26,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":26,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_4-4":
{
	"frame": {"x":61,"y":1255,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_4-5":
{
	"frame": {"x":61,"y":1287,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_5-0":
{
	"frame": {"x":165,"y":244,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_5-1":
{
	"frame": {"x":197,"y":248,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_5-2":
{
	"frame": {"x":101,"y":239,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_5-3":
{
	"frame": {"x":133,"y":252,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_5-4":
{
	"frame": {"x":101,"y":268,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grass/transition/rocky/rockygrass_tran_5-5":
{
	"frame": {"x":133,"y":281,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/grassland_tile_01":
{
	"frame": {"x":165,"y":273,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/grassland_tile_02":
{
	"frame": {"x":197,"y":277,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/grassland_tile_03":
{
	"frame": {"x":101,"y":297,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/grassland_tile_04":
{
	"frame": {"x":133,"y":310,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/grassland_tile_05":
{
	"frame": {"x":165,"y":302,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/grassland_tile_06":
{
	"frame": {"x":197,"y":306,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/grassland_tile_07":
{
	"frame": {"x":165,"y":331,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/grassland_tile_08":
{
	"frame": {"x":197,"y":335,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/grassland_tile_09":
{
	"frame": {"x":81,"y":1319,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/grassland_tile_10":
{
	"frame": {"x":83,"y":1351,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/grassland_tile_11":
{
	"frame": {"x":88,"y":1383,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/grassland_tile_12":
{
	"frame": {"x":88,"y":1415,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/grassland_tile_13":
{
	"frame": {"x":88,"y":1447,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/grassland_tile_14":
{
	"frame": {"x":88,"y":1479,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/grassland_tile_15":
{
	"frame": {"x":88,"y":1511,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/grassland_tile_16":
{
	"frame": {"x":88,"y":1543,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_1-0":
{
	"frame": {"x":163,"y":1696,"w":18,"h":5},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":18,"h":5},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_1-1":
{
	"frame": {"x":189,"y":1656,"w":13,"h":16},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":17,"y":3,"w":13,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_1-2":
{
	"frame": {"x":199,"y":1694,"w":10,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":20,"y":15,"w":10,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_1-3":
{
	"frame": {"x":222,"y":1662,"w":18,"h":6},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":24,"w":18,"h":6},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_1-4":
{
	"frame": {"x":236,"y":1304,"w":14,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":14,"w":14,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_1-5":
{
	"frame": {"x":204,"y":1662,"w":10,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":10,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_2-0":
{
	"frame": {"x":236,"y":882,"w":24,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_2-1":
{
	"frame": {"x":159,"y":1009,"w":11,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":19,"y":3,"w":11,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_2-2":
{
	"frame": {"x":33,"y":302,"w":24,"h":15},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":15,"w":24,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_2-3":
{
	"frame": {"x":33,"y":328,"w":24,"h":15},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":15,"w":24,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_2-4":
{
	"frame": {"x":103,"y":950,"w":12,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":12,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_2-5":
{
	"frame": {"x":236,"y":908,"w":24,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_3-0":
{
	"frame": {"x":165,"y":1022,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_3-1":
{
	"frame": {"x":168,"y":1051,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_3-2":
{
	"frame": {"x":65,"y":1704,"w":30,"h":18},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":12,"w":30,"h":18},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_3-3":
{
	"frame": {"x":168,"y":1080,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_3-4":
{
	"frame": {"x":168,"y":1109,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_3-5":
{
	"frame": {"x":165,"y":360,"w":30,"h":18},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":18},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_4-0":
{
	"frame": {"x":168,"y":1138,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_4-1":
{
	"frame": {"x":88,"y":1575,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_4-2":
{
	"frame": {"x":88,"y":1607,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_4-3":
{
	"frame": {"x":88,"y":1112,"w":26,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":26,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_4-4":
{
	"frame": {"x":88,"y":1639,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_4-5":
{
	"frame": {"x":88,"y":1671,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_5-0":
{
	"frame": {"x":133,"y":339,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_5-1":
{
	"frame": {"x":133,"y":368,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_5-2":
{
	"frame": {"x":165,"y":380,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_5-3":
{
	"frame": {"x":197,"y":384,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_5-4":
{
	"frame": {"x":133,"y":397,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/grassland/transition/grassland_tran_5-5":
{
	"frame": {"x":165,"y":409,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_01":
{
	"frame": {"x":197,"y":413,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_02":
{
	"frame": {"x":137,"y":64,"w":30,"h":30},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":30,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_03":
{
	"frame": {"x":203,"y":1,"w":30,"h":30},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":30,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_04":
{
	"frame": {"x":32,"y":453,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_05":
{
	"frame": {"x":32,"y":485,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_06":
{
	"frame": {"x":32,"y":517,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_07":
{
	"frame": {"x":1,"y":231,"w":30,"h":30},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":30,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_08":
{
	"frame": {"x":32,"y":549,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_09":
{
	"frame": {"x":1,"y":647,"w":30,"h":29},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":1,"w":30,"h":29},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_10":
{
	"frame": {"x":32,"y":581,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_11":
{
	"frame": {"x":32,"y":613,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_12":
{
	"frame": {"x":32,"y":645,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_13":
{
	"frame": {"x":1,"y":263,"w":30,"h":30},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":30,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_14":
{
	"frame": {"x":1,"y":295,"w":30,"h":30},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":30,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_15":
{
	"frame": {"x":32,"y":677,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_16":
{
	"frame": {"x":61,"y":444,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_17":
{
	"frame": {"x":1,"y":327,"w":30,"h":30},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":30,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_18":
{
	"frame": {"x":61,"y":476,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_19":
{
	"frame": {"x":61,"y":508,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_20":
{
	"frame": {"x":61,"y":540,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_21":
{
	"frame": {"x":1,"y":359,"w":30,"h":30},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":30,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_22":
{
	"frame": {"x":61,"y":572,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_23":
{
	"frame": {"x":1,"y":679,"w":30,"h":29},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":1,"w":30,"h":29},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_24":
{
	"frame": {"x":1,"y":391,"w":30,"h":30},
	"rotated": false,
	"trimmed": false,
	"spriteSourceSize": {"x":0,"y":0,"w":30,"h":30},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_25":
{
	"frame": {"x":61,"y":604,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/mountain_tile_26":
{
	"frame": {"x":61,"y":636,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_1-0":
{
	"frame": {"x":245,"y":1652,"w":18,"h":7},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":18,"h":7},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_1-1":
{
	"frame": {"x":222,"y":1268,"w":12,"h":16},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":18,"y":3,"w":12,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_1-2":
{
	"frame": {"x":211,"y":1689,"w":13,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":17,"y":15,"w":13,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_1-3":
{
	"frame": {"x":226,"y":1687,"w":18,"h":5},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":25,"w":18,"h":5},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_1-4":
{
	"frame": {"x":202,"y":1711,"w":11,"h":15},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":15,"w":11,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_1-5":
{
	"frame": {"x":230,"y":1652,"w":13,"h":16},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":13,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_2-0":
{
	"frame": {"x":222,"y":1320,"w":24,"h":18},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":18},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_2-1":
{
	"frame": {"x":165,"y":1618,"w":12,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":18,"y":3,"w":12,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_2-2":
{
	"frame": {"x":33,"y":354,"w":24,"h":15},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":15,"w":24,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_2-3":
{
	"frame": {"x":33,"y":380,"w":24,"h":15},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":15,"w":24,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_2-4":
{
	"frame": {"x":208,"y":1460,"w":13,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":13,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_2-5":
{
	"frame": {"x":236,"y":934,"w":24,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_3-0":
{
	"frame": {"x":168,"y":1167,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_3-1":
{
	"frame": {"x":168,"y":1196,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_3-2":
{
	"frame": {"x":235,"y":1,"w":30,"h":17},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":13,"w":30,"h":17},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_3-3":
{
	"frame": {"x":168,"y":1225,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_3-4":
{
	"frame": {"x":169,"y":1254,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_3-5":
{
	"frame": {"x":197,"y":364,"w":30,"h":18},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":18},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_4-0":
{
	"frame": {"x":191,"y":1011,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_4-1":
{
	"frame": {"x":135,"y":144,"w":30,"h":26},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":4,"w":30,"h":26},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_4-2":
{
	"frame": {"x":61,"y":668,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_4-3":
{
	"frame": {"x":194,"y":1040,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_4-4":
{
	"frame": {"x":110,"y":426,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_4-5":
{
	"frame": {"x":165,"y":438,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_5-0":
{
	"frame": {"x":197,"y":442,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_5-1":
{
	"frame": {"x":90,"y":473,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_5-2":
{
	"frame": {"x":90,"y":505,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_5-3":
{
	"frame": {"x":90,"y":537,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_5-4":
{
	"frame": {"x":90,"y":569,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/mountain/transition/mountain_tran_5-5":
{
	"frame": {"x":90,"y":601,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/ocean_tile_01":
{
	"frame": {"x":90,"y":633,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/ocean_tile_02":
{
	"frame": {"x":90,"y":665,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_1-0":
{
	"frame": {"x":221,"y":1208,"w":21,"h":13},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":3,"w":21,"h":13},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_1-1":
{
	"frame": {"x":50,"y":303,"w":15,"h":19},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":15,"y":3,"w":15,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_1-2":
{
	"frame": {"x":221,"y":1231,"w":13,"h":17},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":17,"y":13,"w":13,"h":17},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_1-3":
{
	"frame": {"x":206,"y":833,"w":20,"h":9},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":21,"w":20,"h":9},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_1-4":
{
	"frame": {"x":190,"y":1635,"w":15,"h":19},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":11,"w":15,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_1-5":
{
	"frame": {"x":207,"y":1636,"w":15,"h":19},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":15,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_2-0":
{
	"frame": {"x":167,"y":1461,"w":25,"h":20},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":3,"w":25,"h":20},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_2-1":
{
	"frame": {"x":205,"y":1356,"w":16,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":14,"y":3,"w":16,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_2-2":
{
	"frame": {"x":217,"y":723,"w":25,"h":17},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":13,"w":25,"h":17},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_2-3":
{
	"frame": {"x":235,"y":1410,"w":26,"h":17},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":13,"w":26,"h":17},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_2-4":
{
	"frame": {"x":129,"y":1703,"w":19,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":19,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_2-5":
{
	"frame": {"x":217,"y":750,"w":25,"h":17},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":25,"h":17},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_3-0":
{
	"frame": {"x":194,"y":1156,"w":25,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":3,"w":25,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_3-1":
{
	"frame": {"x":194,"y":1185,"w":25,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":3,"w":25,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_3-2":
{
	"frame": {"x":110,"y":455,"w":30,"h":16},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":14,"w":30,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_3-3":
{
	"frame": {"x":130,"y":871,"w":27,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":27,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_3-4":
{
	"frame": {"x":159,"y":871,"w":27,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":27,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_3-5":
{
	"frame": {"x":97,"y":1703,"w":30,"h":19},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_4-0":
{
	"frame": {"x":194,"y":1214,"w":25,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":3,"w":25,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_4-1":
{
	"frame": {"x":119,"y":473,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_4-2":
{
	"frame": {"x":119,"y":505,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_4-3":
{
	"frame": {"x":177,"y":695,"w":28,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":28,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_4-4":
{
	"frame": {"x":119,"y":537,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_4-5":
{
	"frame": {"x":119,"y":569,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_5-0":
{
	"frame": {"x":119,"y":601,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_5-1":
{
	"frame": {"x":119,"y":633,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_5-2":
{
	"frame": {"x":119,"y":665,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_5-3":
{
	"frame": {"x":148,"y":472,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_5-4":
{
	"frame": {"x":148,"y":504,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/ocean/transition/ocean_tran_5-5":
{
	"frame": {"x":148,"y":536,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/snow_tile_01":
{
	"frame": {"x":148,"y":568,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/snow_tile_02":
{
	"frame": {"x":148,"y":600,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/snow_tile_03":
{
	"frame": {"x":148,"y":632,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/snow_tile_04":
{
	"frame": {"x":148,"y":664,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/snow_tile_05":
{
	"frame": {"x":197,"y":471,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_1-0":
{
	"frame": {"x":245,"y":1672,"w":18,"h":7},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":18,"h":7},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_1-1":
{
	"frame": {"x":236,"y":1236,"w":17,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":13,"y":3,"w":17,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_1-2":
{
	"frame": {"x":240,"y":1374,"w":12,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":18,"y":15,"w":12,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_1-3":
{
	"frame": {"x":180,"y":1685,"w":18,"h":7},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":23,"w":18,"h":7},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_1-4":
{
	"frame": {"x":163,"y":1679,"w":15,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":15,"w":15,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_1-5":
{
	"frame": {"x":222,"y":1340,"w":14,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":14,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_2-0":
{
	"frame": {"x":236,"y":960,"w":24,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_2-1":
{
	"frame": {"x":241,"y":1481,"w":11,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":19,"y":3,"w":11,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_2-2":
{
	"frame": {"x":33,"y":406,"w":24,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":15,"w":24,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_2-3":
{
	"frame": {"x":50,"y":228,"w":24,"h":15},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":15,"w":24,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_2-4":
{
	"frame": {"x":205,"y":724,"w":10,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":10,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_2-5":
{
	"frame": {"x":236,"y":986,"w":24,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_3-0":
{
	"frame": {"x":229,"y":372,"w":23,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":7,"y":3,"w":23,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_3-1":
{
	"frame": {"x":194,"y":1069,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_3-2":
{
	"frame": {"x":197,"y":616,"w":30,"h":19},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":11,"w":30,"h":19},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_3-3":
{
	"frame": {"x":194,"y":1098,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_3-4":
{
	"frame": {"x":194,"y":1127,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_3-5":
{
	"frame": {"x":177,"y":467,"w":30,"h":18},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":18},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_4-0":
{
	"frame": {"x":195,"y":1243,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_4-1":
{
	"frame": {"x":197,"y":500,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_4-2":
{
	"frame": {"x":197,"y":529,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_4-3":
{
	"frame": {"x":112,"y":1348,"w":25,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":25,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_4-4":
{
	"frame": {"x":197,"y":558,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_4-5":
{
	"frame": {"x":197,"y":587,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_5-0":
{
	"frame": {"x":177,"y":637,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_5-1":
{
	"frame": {"x":177,"y":666,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_5-2":
{
	"frame": {"x":209,"y":637,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_5-3":
{
	"frame": {"x":209,"y":666,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_5-4":
{
	"frame": {"x":60,"y":726,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/plain/snow_tran_5-5":
{
	"frame": {"x":60,"y":758,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_1-0":
{
	"frame": {"x":204,"y":793,"w":18,"h":11},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":18,"h":11},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_1-1":
{
	"frame": {"x":212,"y":880,"w":22,"h":16},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":8,"y":3,"w":22,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_1-2":
{
	"frame": {"x":183,"y":1694,"w":14,"h":15},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":16,"y":15,"w":14,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_1-3":
{
	"frame": {"x":52,"y":216,"w":18,"h":10},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":20,"w":18,"h":10},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_1-4":
{
	"frame": {"x":236,"y":1255,"w":15,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":14,"w":15,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_1-5":
{
	"frame": {"x":236,"y":1090,"w":20,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":20,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_2-0":
{
	"frame": {"x":236,"y":1012,"w":24,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_2-1":
{
	"frame": {"x":220,"y":1124,"w":13,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":17,"y":3,"w":13,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_2-2":
{
	"frame": {"x":50,"y":254,"w":24,"h":15},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":15,"w":24,"h":15},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_2-3":
{
	"frame": {"x":236,"y":1038,"w":24,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":14,"w":24,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_2-4":
{
	"frame": {"x":223,"y":1460,"w":15,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":15,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_2-5":
{
	"frame": {"x":236,"y":1064,"w":24,"h":16},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":16},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_3-0":
{
	"frame": {"x":142,"y":1309,"w":25,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":5,"y":3,"w":25,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_3-1":
{
	"frame": {"x":196,"y":1272,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":6,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_3-2":
{
	"frame": {"x":165,"y":190,"w":30,"h":23},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":7,"w":30,"h":23},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_3-3":
{
	"frame": {"x":196,"y":1301,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_3-4":
{
	"frame": {"x":117,"y":1377,"w":24,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":24,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_3-5":
{
	"frame": {"x":88,"y":383,"w":30,"h":20},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":20},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_4-0":
{
	"frame": {"x":88,"y":1141,"w":26,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":4,"y":3,"w":26,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_4-1":
{
	"frame": {"x":60,"y":790,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_4-2":
{
	"frame": {"x":60,"y":822,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_4-3":
{
	"frame": {"x":104,"y":964,"w":26,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":26,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_4-4":
{
	"frame": {"x":72,"y":871,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_4-5":
{
	"frame": {"x":91,"y":697,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_5-0":
{
	"frame": {"x":89,"y":726,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_5-1":
{
	"frame": {"x":89,"y":755,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_5-2":
{
	"frame": {"x":89,"y":784,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_5-3":
{
	"frame": {"x":89,"y":813,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_5-4":
{
	"frame": {"x":90,"y":842,"w":30,"h":27},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
},
"tiles/snow/transition/rocky/rockysnow_tran_5-5":
{
	"frame": {"x":121,"y":727,"w":30,"h":27},
	"rotated": true,
	"trimmed": true,
	"spriteSourceSize": {"x":0,"y":3,"w":30,"h":27},
	"sourceSize": {"w":30,"h":30},
	"pivot": {"x":0.5,"y":0.5}
}},
"meta": {
	"app": "https://www.codeandweb.com/texturepacker",
	"version": "1.0",
	"image": "tiles.png",
	"format": "RGBA8888",
	"size": {"w":253,"h":1723},
	"scale": "1",
	"smartupdate": "$TexturePacker:SmartUpdate:2f132c918b00125e8863d152bbd5cf44:a7154ad13bfa03e4d6c22009a5de6bf7:accbe1e7e294ded8391337fc1c446319$"
}
}
